import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { RouterModule, Routes, Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class TitleMetaService {
    constructor(private titleService: Title, private metaService: Meta) { }

    setTitle(title: string) {
        this.titleService.setTitle(title);
    }

    setMetaDescription(description: string) {
        this.metaService.updateTag({ name: 'description', content: description });
    }

    setMetaKeywords(keywords: string) {
        this.metaService.updateTag({ name: 'keywords', content: keywords });
    }

}